
export interface DmnDefinition {
  id: string;
  name: string;
  inputs: { name: string; type: string }[];
  outputs: { name: string; type: string }[];
}

export const mockDmnFiles: DmnDefinition[] = [
  {
    id: 'risk_assessment.dmn',
    name: 'Risk Assessment',
    inputs: [
      { name: 'amount', type: 'number' },
      { name: 'customerType', type: 'string' }
    ],
    outputs: [
      { name: 'riskScore', type: 'number' },
      { name: 'riskLevel', type: 'string' }
    ]
  },
  {
    id: 'discount_rules.dmn',
    name: 'Discount Rules',
    inputs: [
      { name: 'cartTotal', type: 'number' },
      { name: 'couponCode', type: 'string' }
    ],
    outputs: [
      { name: 'discountPercent', type: 'number' }
    ]
  },
  {
    id: 'loan_eligibility.dmn',
    name: 'Loan Eligibility',
    inputs: [
        { name: 'creditScore', type: 'number' },
        { name: 'annualIncome', type: 'number' },
        { name: 'loanAmount', type: 'number' }
    ],
    outputs: [
        { name: 'isEligible', type: 'boolean' },
        { name: 'interestRate', type: 'number' }
    ]
  }
];

export class DmnService {
  private definitions: DmnDefinition[];

  constructor(definitions: DmnDefinition[] = mockDmnFiles) {
    this.definitions = definitions;
  }

  async getDefinitions(): Promise<DmnDefinition[]> {
    return new Promise(resolve => setTimeout(() => resolve(this.definitions), 500));
  }
  
  async getDefinitionById(id: string): Promise<DmnDefinition | undefined> {
      return new Promise(resolve => setTimeout(() => resolve(this.definitions.find(d => d.id === id)), 200));
  }
}

export const dmnService = new DmnService();
